import {
  Component,
  OnInit,
} from "@angular/core";
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";
import { DataService } from "../../services/data.service"
import { CaMasterService, } from "../../../shared/services/accounts/ca-master.service";
import { MainService } from "../../../shared/services/main.service";
import { CaTransService } from "../../../shared/services/accounts/ca-trans.service";
import { DatePipe } from '@angular/common';

export interface UnPostItems {
  title: string;
  data: any;
}

@Component({
  selector: 'app-unpostpdc-popup',
  templateUrl: './unpostpdc-popup.component.html',
  styleUrls: ['./unpostpdc-popup.component.css']
})

export class UnpostPdcPopUpComponent extends DialogComponent<UnPostItems, boolean>
  implements UnPostItems, OnInit {

    title: string;
    data: any ;

  FilterData=new UnpostFilter();
  result: any = { result: false, RtnItem: {} };
  UnpostList:any=[];
  bankList: any = [];
  loading:boolean=false;
  branch: any = [];
  selectAll:boolean=false;

  constructor(dialogService: DialogService, private ds: DataService, public datepipe: DatePipe,private ca: CaMasterService,
    private main: MainService,private cat: CaTransService) {
    super(dialogService);
  }
  ngOnChanges() {

  }
  ngOnInit() {
    this.clear();
    this.getBankHead();
    this.GetBranch();

  }

  ok() {
   this.UnpostPdc();
  }

  clear() {
    this.loading=false;
    this.FilterData=new UnpostFilter();
    this.FilterData.BranchId = this.ds.Settings.BranchId;
    this.UnpostList=[];
    this.selectAll=false;
  }

  getBankHead() {
    var a = {
      GroupId: this.ds.Settings.BankHead,
      RequestDataList: {
        Start: 0,
        FiterText: "",
        Limit: this.ds.Settings.MaxLimit,
        ItemTypeId: this.ds.Settings.ItemTypeId,
        CAType: this.ds.Settings.CAType
      }
    };
    this.loading=true;
    this.ca.GetLedgerByMainGroupId(a).subscribe(res => {
      this.bankList = [];

      for (let i of res.data) {
        this.bankList.push({ Id: i.Id, Name: i.Id + ' - ' + i.Name });
      }
      this.loading = false;
    }, (err) => { }, () => {
      this.loading = false;
    });
  }

  GetBranch() {
    var a = {
      CompanyId: this.ds.Settings.CompanyId,
      RequestedList: {
        Start: 0,
        FiterText: "",
        Limit: this.ds.Settings.MaxLimit,
        ItemTypeId: this.ds.Settings.ItemTypeId,
        CAType: this.ds.Settings.CAType
      }
    }
    this.loading=true;
    this.main.GetBranch(a).subscribe(res => {
      this.branch = [];

      for (let i of res.data) {
        this.branch.push({ Id: i.Id, Name: i.Id + ' - ' + i.Name });
      }
      this.loading = false;
    }, (err) => { }, () => {
      this.FilterData.BranchId = this.ds.Settings.BranchId;
      this.loading = false;
    });
  }

  LoadList(){
    var vtype =0
    if(this.data){
       vtype=1
    }
    else{
      vtype=2
    }
    if(vtype==2 && this.FilterData.BankId==0){
     alert("Please Select Bank");
    }
    else{
      var data: any = {
        FromDate: this.FilterData.FromDate,
        ToDate:this.FilterData.ToDate,
        BranchId:this.FilterData.BranchId,
        VoucherType:vtype,
        Id:this.FilterData.BankId,
        VoucherFlag:this.data
      }
      this.loading = true;
      this.cat.Get_UnpostPdcPosting(data).subscribe(res => {
        if (res.Success) {
          this.UnpostList=res.data;
          this.loading = true;
        } else {
          this.UnpostList=[];
          this.loading = true;
          alert(res.error.UsrMsg);
        }       
      });
    }
  }

  change(e){
    for (let i of this.UnpostList) {
      i.Selected = this.selectAll
    }
  }

  selectionChange(e){
    console.log(e);
    if (!e.Selected) {     
      this.selectAll = false;
    }
    for (let i of this.UnpostList) {
      if (i.Selected == false) {
        this.selectAll = false;
        break;
      } else {
        this.selectAll = true;
      }
    }
  }

  UnpostPdc(){
    var UnpostSaveList=[];
    for(let i of this.UnpostList){
      if(i.Selected){
        UnpostSaveList.push(i)
      }
    }

    if(UnpostSaveList.length==0){
      alert("No Item(s) Selected");
    }
    else{
      this.loading = true;
      this.cat.Pdc_Unpost(UnpostSaveList).subscribe(res => {
        if (res.Success) {
          alert("Pdc Unposted Succesfully");
          this.loading = true;
          UnpostSaveList=[];
          this.clear();
        } else {
          this.UnpostList=[];
          this.loading = true;
          alert(res.error.UsrMsg);
        }       
      });
    }
  }

  fromdateLeave(){

  }

  fromdateKeyDown(e){

  }
  todateLeave(){

  }
  todateKeyDown(e){

  }

}

class UnpostFilter{
  FromDate:Date=new Date();
  ToDate:Date=new Date();
  BranchId:number=0;
  BankId:number=0;
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/unpostpdc-popup/unpostpdc-popup.component.ts